import { FunctionComponent } from 'react';
import { V2StreetViewComponent } from '@terragotech/page-renderer';
import styled from 'styled-components';
import { NestedPageControlProps } from '../PageTypes';
import { StandardInputFrame, Label, LabelSubText } from './Common';
import { colors } from 'utils/colors';
import _ from 'lodash';
import { CustomPageBadges } from './CustomPageBadges';

const Placeholder = styled.div`
  font-size: 16px;
  line-height: 19px;
  text-align: left;
  color: ${colors.title};
  margin-right: 15px;
`;
const PlaceHolderFrame = styled.div`
  display: flex;
  margin-left: 15px;
  margin-bottom: 12px;
`;

const PastedMark = styled.div`
  position: absolute;
  margin: 5px;
  right: 0;
  bottom: 0;
  font-weight: 700;
  font-size: 12px;
`;
interface streetViewComponent extends V2StreetViewComponent {
  placeholder?: string;
}
const StreetViewControl: FunctionComponent<NestedPageControlProps<streetViewComponent>> = (
  props
) => {
  const { controlDefinition, pasted, isPageEditor } = props;
  const capitalizedControlType = _.upperFirst(controlDefinition.type);
  return (
    <StandardInputFrame>
      <Label
        text={controlDefinition.label}
        isPageEditor
        conditional={Boolean(controlDefinition.displayOptions)}
      />
      {isPageEditor && (
        <LabelSubText isDisplayOptionsEnabled={Boolean(controlDefinition.displayOptions)}>
          {capitalizedControlType}
        </LabelSubText>
      )}
      <PlaceHolderFrame>
        <Placeholder>{controlDefinition.placeholder}</Placeholder>
      </PlaceHolderFrame>
      <CustomPageBadges controlDefinition={controlDefinition} showConditionalMap />
      {pasted && <PastedMark>Pasted</PastedMark>}
    </StandardInputFrame>
  );
};
export default StreetViewControl;
